import { render, staticRenderFns } from "./MainRightpart.vue?vue&type=template&id=8a2cd440&scoped=true"
import script from "./MainRightpart.vue?vue&type=script&lang=js"
export * from "./MainRightpart.vue?vue&type=script&lang=js"
import style0 from "./MainRightpart.vue?vue&type=style&index=0&id=8a2cd440&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a2cd440",
  null
  
)

export default component.exports